module.exports = __webpack_public_path__ + "img/laboratorio_3-4.9b4d4530.jpg";